export const locationHasParentLocation = (location = {}) =>
  !!location.parentLocation
